export class Video {
    videoId: number
    title:string
    url:string
    docname:string
    document:string
    requiredClaim:string
    franchiseId:number
}
